import React from 'react'

import { Box, Typography, useTheme, useMediaQuery } from '@mui/material'

const isVideoFile = (url: string) => {
  const videoExtensions = ['mp4', 'webm', 'ogg', 'mov']
  const extension = url.split('.').pop()?.toLowerCase()

  
return extension ? videoExtensions.includes(extension) : false
}

const UcapanDukaMediaCard = ({ rowData }: { rowData: any }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isTablet = useMediaQuery(theme.breakpoints.down('md'))
  const mediaUrl = process.env.NEXT_PUBLIC_URL_IMAGE_TEMPLATE + (rowData?.GAMBAR || '')

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        aspectRatio: { xs: '16/7', sm: '16/6', md: '16/5' }, // Lebih memanjang horizontal
        minHeight: { xs: 120, sm: 160, md: 180 },
        maxHeight: { xs: 180, sm: 220, md: 260 },
        borderRadius: 1,
        overflow: 'hidden',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        background: '#222',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: '0 12px 40px rgba(0, 0, 0, 0.2)'
        }
      }}
    >
      {/* Background Media */}
      {isVideoFile(rowData?.GAMBAR || '') ? (
        <Box
          component='video'
          src={mediaUrl}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 1
          }}
          autoPlay
          loop
          muted
          playsInline
        />
      ) : (
        <Box
          component='img'
          src={mediaUrl}
          alt='Ucapan Duka'
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 1
          }}
        />
      )}

      {/* Gradient Overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(135deg, rgba(0,0,0,0.25) 0%, rgba(0,0,0,0.05) 50%, rgba(0,0,0,0.3) 100%)',
          zIndex: 2
        }}
      />

      {/* Text Overlay */}
      <Box
        sx={{
          position: 'relative',
          zIndex: 3,
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          px: { xs: 2, sm: 3, md: 4 },
          py: { xs: 2, sm: 2.5, md: 3 }
        }}
      >
        <Typography
          variant='subtitle2'
          fontWeight='bold'
          sx={{
            color: 'white',
            textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
            fontSize: { xs: '0.85rem', sm: '1rem', md: '1.2rem', lg: '1.3rem' },
            mb: 0.5,
            lineHeight: 1.1,
            wordBreak: 'break-word'
          }}
        >
          {rowData?.JUDUL_UCAPAN}
        </Typography>
        <Typography
          variant='caption'
          sx={{
            fontWeight: 'bold',
            color: 'rgba(255,255,255,0.9)',
            textShadow: '1px 1px 4px rgba(0,0,0,0.6)',
            fontSize: { xs: '0.6rem', sm: '0.8rem', md: '0.9rem' },
            mb: 0.5
          }}
        >
          Atas Meninggalnya
        </Typography>
        <Typography
          variant='h6'
          fontWeight='bold'
          sx={{
            color: 'white',
            textShadow: '2px 2px 8px rgba(0,0,0,0.8)',
            fontSize: { xs: '1rem', sm: '1.2rem', md: '1.4rem', lg: '1.5rem' },
            mb: 0.5,
            lineHeight: 1.1,
            wordBreak: 'break-word'
          }}
        >
          {rowData?.PENERIMA || '\u00A0'}
        </Typography>
        {rowData?.KET_PENERIMA && (
          <Typography
            variant='caption'
            fontWeight='bold'
            sx={{
              color: 'rgba(255,255,255,0.9)',
              textShadow: '1px 1px 4px rgba(0,0,0,0.6)',
              fontSize: { xs: '0.6rem', sm: '0.8rem', md: '0.9rem' },
              mb: 0.5
            }}
          >
            {rowData?.KET_PENERIMA}
          </Typography>
        )}
        {rowData?.KET_PENGIRIM && (
          <Typography
            variant='caption'
            fontWeight='bold'
            sx={{
              color: 'rgba(255,255,255,0.9)',
              textShadow: '1px 1px 4px rgba(0,0,0,0.6)',
              fontSize: { xs: '0.6rem', sm: '0.8rem', md: '0.9rem' }
            }}
          >
            {rowData?.KET_PENGIRIM}
          </Typography>
        )}
        <Typography
          variant='subtitle2'
          fontWeight='bold'
          sx={{
            color: 'white',
            textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
            fontSize: { xs: '0.85rem', sm: '1rem', md: '1.2rem', lg: '1.3rem' },
            mt: 0.5,
            lineHeight: 1.1,
            wordBreak: 'break-word'
          }}
        >
          {rowData?.PENGIRIM || '\u00A0'}
        </Typography>
      </Box>
    </Box>
  )
}

export default UcapanDukaMediaCard
